'use client';

const styles = `
  * {
    line-height: 1.2;
    margin: 0;
  }

  html {
      font-size: 16px;
      height: 100%;
  }

  body {
    color: #033030;
    font-family: Helvetica, Arial, sans-serif;
  }

  h1, h2, h3 {
      font-family: Times, 'Times New Roman', serif;
      font-weight: 300;
  }

  a {
      color: #074F4F;
  }

  a:hover {
      opacity: 90%;
  }

  .bg-light-grey {
      background: #F8F5F1;
  }
  
  .text-primary {
      color: #074F4F;
  }

  .flex {
      display: flex;
  }

  .flex-1 {
      flex: 1 1 0%;
  }

  .flex-col {
      flex-direction: column;
  }

  .gap-4 {
      gap: 1rem;
  }

  .items-center {
      align-items: center;
  }

  .justify-center {
      justify-content: center;
  }

  .p-4 {
      padding: 1rem;
  }

  .p-8 {
      padding: 2rem;
  }

  .mb-4 {
      margin-bottom: 1rem;
  }

  .my-16 {
      margin: 4rem 0;
  }

  .w-3-4 {
      width: 75%;
  }

  .inline-block {
      display: inline-block;
  }

  .w-32 {
      width: 32px;
  }

  .logo {
      width: 200px;
  }

  @media (min-width: 768px) {
      h1 {
          font-size: 2.5rem;
      }

      .logo {
          width: 240px;
      }

      .md-p-8 {
          padding: 2rem;
      }
  }

  @media (min-width: 1024px) {
      h1 {
          font-size: 4rem;
      }

      .lg-w-1-2 {
          width: 50%;
      }

      .lg-p-12 {
          padding: 3rem;
      }

      .lg-w-3-4 {
          width: 75%;
      }

      .lg-h-full {
          height: 100%;
      }

      .lg-flex {
          display: flex;
      }
  }
`;

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <html lang="ro">
            <head>
                <meta charSet="utf-8" />
                <title>Bioclinica - Eroare 500</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <style dangerouslySetInnerHTML={{ __html: styles }} />
            </head>

            <body className="lg-h-full">
                <div className="lg-flex lg-h-full">
                    <div className="lg-w-1-2 md-p-8 lg-p-12 lg-flex flex-col p-4">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0"
                            y="0"
                            viewBox="0 0 1037.9 160"
                            className="text-primary logo">
                            <path
                                fill="currentColor"
                                d="M289.4 82.9a49 49 0 0 0-26-6.9h3.1c6.3-1.8 11.7-4.7 16.3-8.5s6.9-8 6.9-12.4c0-6.5-3.8-12.1-11.4-16.7a49 49 0 0 0-26-6.9H200c.6.7 1.7 1.7 3.2 2.9 1.5 1.2 2.7 2.4 3.6 3.4.9 1 1.4 2 1.4 2.9v85.9h56.2a41 41 0 0 0 25-7.9c7.6-5.3 11.4-11.7 11.4-19.2v-.1c0-6.3-3.8-11.9-11.4-16.5zm-63.6-47.5h22.8c16.2 0 24.4 6.7 24.4 20.1 0 7.7-1.8 12.8-5.2 15.2a28.9 28.9 0 0 1-16.1 3.6l-25.8.1-.1-39zm32.9 86.5h-32.8V80.5h32.8c16.1 0 25.2 6 25.3 19.2-.1 15.1-9.2 22.2-25.3 22.2zm69.1-90.3v95.2h-16V31.6h16zm70-1.4c13.9 1 25.1 6.7 33.5 17.1s11.7 22.3 9.9 35.8c-1.9 13.6-8.3 24.7-19.4 33.5s-23.5 12.7-37.3 11.6c-13.8-1-25-6.7-33.5-17.1-8.5-10.2-11.9-22.1-10-35.6s8.3-24.7 19.4-33.6a51.1 51.1 0 0 1 37.4-11.7zm-18.9 88.2c10.4-1.1 21.1-6.1 32.2-14.9s18.3-18.3 21.6-28.5 2-19.2-4.1-26.9a23.4 23.4 0 0 0-15.3-8.6 40 40 0 0 0-19.5 2.5c-6.9 2.5-14.3 6.5-22.2 11.9-11.5 7.8-19 17.1-22.4 27.8s-1.9 19.9 4.4 27.4a28 28 0 0 0 25.3 9.3zm86.5-38.8c0 13.1 3.4 23.6 10.1 31.6s15.2 12 25.4 12a45.5 45.5 0 0 0 27.8-9.8 84.5 84.5 0 0 0 16-15.4v7.3c-2.6 2.8-4.5 4.7-5.6 5.7-12.9 11.7-25.7 17.5-38.4 17.4a57.4 57.4 0 0 1-39.3-14.3 44.9 44.9 0 0 1-12.3-51.2c2.4-5.7 5.7-11 10.1-15.9s10.2-9 17.5-12.1a61.6 61.6 0 0 1 24.3-4.7c7.1-.2 13.4.4 18.9 1.6 5.5 1.3 12.2 3.4 20.1 6.4l.7 30.7c-1.5-1.9-3.4-5.2-5.5-9.9s-4.5-9-7-13.1c-2.5-4-5.5-7-9-8.8-7.2-4-14-5.6-20.5-4.8a35 35 0 0 0-29.1 23.5 68 68 0 0 0-4.2 23.8zm166.8 41.6v5.6h-74.9V31.6H575v89.6h57.2zm24-89.6v95.2h-16V31.6h16zm108.1 95.2-81.6-83.1v83h-5.4v-89l-6.5-6.1h25.6l75.1 75.1V31.6h5v95.2h-12.2zm47-95.2v95.2h-16V31.6h16zm32.8 48c0 13.1 3.3 23.6 10.1 31.6s15.2 12 25.4 12a45.5 45.5 0 0 0 27.8-9.8 84.5 84.5 0 0 0 16-15.4v7.3c-2.6 2.8-4.5 4.7-5.6 5.7-12.9 11.7-25.7 17.5-38.3 17.4a57.4 57.4 0 0 1-39.3-14.3 44.9 44.9 0 0 1-12.3-51.2c2.3-5.7 5.7-10.9 10.1-15.9s10.2-9 17.5-12.1a61.6 61.6 0 0 1 24.3-4.7c7.1-.2 13.4.4 18.9 1.6 5.5 1.3 12.2 3.4 20.1 6.4l.7 30.7c-1.5-1.9-3.4-5.2-5.5-9.9s-4.5-9-7-13.1c-2.5-4-5.5-7-9-8.8-7.2-4-14-5.6-20.5-4.8a35 35 0 0 0-29.1 23.5 63.7 63.7 0 0 0-4.3 23.8zm156.4 18.2h-58.6l-16.7 29H919l50.3-87.3-9-7.9h22.2l55.3 95.1h-21.1l-16.2-28.9zm-56.1-4.6H998l-26.7-46.7-26.9 46.7zm-804.9-35h-.2a37.6 37.6 0 0 1-37.5-37.5v-.2A20.4 20.4 0 0 0 89.1 1.6 20.3 20.3 0 0 0 66.7 6a20.4 20.4 0 0 0-4.4 22.4 20 20 0 0 0 7.5 9.2c3.4 2.3 7.3 3.5 11.4 3.5h.2a37.6 37.6 0 0 1 37.5 37.5v.2a20.4 20.4 0 0 0 24.6 20 20.4 20.4 0 0 0 16.1-16.1c.8-4 .4-8.1-1.1-11.9a20 20 0 0 0-19-12.6zm-59.1 1.6h-.2a37.6 37.6 0 0 1-37.5-37.5V22A20.4 20.4 0 0 0 18.1 2 20.4 20.4 0 0 0 3.2 30a20.6 20.6 0 0 0 18.9 12.7h.2a37.6 37.6 0 0 1 37.5 37.5v.2a20.4 20.4 0 0 0 24.6 20c4-.8 7.6-2.8 10.5-5.6s4.8-6.5 5.6-10.5c.8-4 .4-8.1-1.1-11.9a20 20 0 0 0-19-12.6h-.2m-1.4 59.1h-.2a37.6 37.6 0 0 1-37.5-37.5v-.2a20.4 20.4 0 0 0-24.6-20A20.2 20.2 0 0 0 1.6 89.1a20 20 0 0 0 7.5 9.2c3.4 2.3 7.3 3.5 11.4 3.5h.2a37.6 37.6 0 0 1 37.5 37.5v.2a20.4 20.4 0 0 0 24.6 20c4-.8 7.6-2.8 10.5-5.6s4.8-6.5 5.6-10.5c.8-4 .4-8.1-1.2-11.9a20 20 0 0 0-18.9-12.6h-.2"
                            />
                        </svg>
                        <div className="lg-flex my-16 flex-1 flex-col justify-center">
                            <h1 className="w-3-4 mb-4">Lucrăm la o experiență nouă, pentru tine.</h1>
                            <p className="lg-w-3-4">
                                Site-ul Bioclinica și Contul tău vor fi din nou disponibile în curând. Dacă ești în
                                așteptarea unor rezultate, fii fără griji, le vei putea accesa în curând. Mulțumim
                                pentru răbdare.
                            </p>
                        </div>
                        <div className="flex gap-4">
                            <a
                                href="https://facebook.com/laboratoarele.bioclinica"
                                className="inline-block w-32"
                                title="Facebook">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path
                                        fill="currentColor"
                                        d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                                    />
                                </svg>
                            </a>

                            <a
                                href="https://instagram.com/laboratoarele.bioclinica"
                                className="inline-block w-32"
                                title="Instagram">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path
                                        fill="currentColor"
                                        d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                                    />
                                </svg>
                            </a>

                            <a
                                href="https://www.youtube.com/channel/UCqGFIgNFyE-R3zFbcpym9Rg"
                                className="inline-block w-32"
                                title="YouTube">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path
                                        fill="currentColor"
                                        d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div className="lg-w-1-2 bg-light-grey lg-flex lg-p-12 flex-col items-center justify-center gap-4 p-8">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 365.762 356.741" className="lg-w-1-2">
                            <defs>
                                <clipPath id="clip-path">
                                    <path
                                        d="M64.755,135.612,18.923,241.094H129.667L83.832,135.612Z"
                                        transform="translate(-18.923 -135.612)"
                                        fill="none"
                                    />
                                </clipPath>
                            </defs>
                            <g transform="translate(-842 -203)">
                                <path
                                    d="M105.266,105.226l8.528-19.316-11.115-4.916a46.158,46.158,0,0,0,.262-14.952l11.422-4.423-7.621-19.689L95.233,46.389A46,46,0,0,0,84.968,35.664l5-11.311L70.659,15.821l-5,11.311a46.036,46.036,0,0,0-14.836-.368L46.368,15.25,26.684,22.875,31.095,34.3A46.016,46.016,0,0,0,20.221,44.56L9.1,39.648.566,58.962l10.991,4.857a45.943,45.943,0,0,0-.414,15.118L0,83.251,7.618,102.94l11.057-4.28a46.035,46.035,0,0,0,10.5,11.057l-4.776,10.8L43.7,129.046l4.775-10.8a46.148,46.148,0,0,0,15.238.316L68,129.619l19.686-7.625-4.307-11.141a45.963,45.963,0,0,0,10.9-10.486Zm-61.108-3.315A31.949,31.949,0,1,1,86.3,85.605a31.949,31.949,0,0,1-42.138,16.307"
                                    transform="translate(842 214.97)"
                                    fill="#daebdb"
                                />
                                <path
                                    d="M6.139,0H307.917a6.138,6.138,0,0,1,6.138,6.138v193.85a6.138,6.138,0,0,1-6.138,6.138H6.138A6.138,6.138,0,0,1,0,199.988V6.139A6.139,6.139,0,0,1,6.139,0Z"
                                    transform="translate(893.706 275.595)"
                                    fill="#fff"
                                />
                                <path
                                    d="M332.069,40.672H39.923A10.987,10.987,0,0,0,28.969,51.628V195.772H343.024V51.628a10.988,10.988,0,0,0-10.956-10.956"
                                    transform="translate(864.738 234.923)"
                                    fill="#074f4f"
                                />
                                <rect
                                    width="289.406"
                                    height="131.479"
                                    transform="translate(906.029 287.404)"
                                    fill="#fff"
                                />
                                <rect
                                    width="77.3"
                                    height="20.676"
                                    transform="translate(1012.082 481.722)"
                                    fill="#fff"
                                />
                                <path
                                    d="M198.878,182.161H85.061L103.32,167.74h77.3Z"
                                    transform="translate(908.763 334.657)"
                                    fill="#fff"
                                />
                                <path
                                    d="M148.447,100.781V87.762h-7.5a28.493,28.493,0,0,0-3.575-8.5l5.337-5.337-9.2-9.206-5.38,5.381a28.356,28.356,0,0,0-8.46-3.489V58.986H106.652v7.623a28.338,28.338,0,0,0-8.46,3.489L92.81,64.717l-9.2,9.206,5.339,5.337a28.351,28.351,0,0,0-3.573,8.5h-7.5v13.019h7.409a28.31,28.31,0,0,0,3.534,8.628l-5.21,5.212,9.2,9.2,5.169-5.167a28.432,28.432,0,0,0,8.673,3.62v7.281h13.015v-7.281a28.432,28.432,0,0,0,8.673-3.62l5.167,5.167,9.2-9.2-5.208-5.212a28.4,28.4,0,0,0,3.536-8.628Zm-35.287,6.167a12.5,12.5,0,1,1,12.5-12.5,12.506,12.506,0,0,1-12.5,12.5"
                                    transform="translate(903.121 249.298)"
                                    fill="#daebdb"
                                />
                                <path
                                    d="M174.376,126.107l4.369-9.888-5.694-2.515a23.592,23.592,0,0,0,.136-7.657l5.847-2.265-3.9-10.081-5.894,2.283a23.53,23.53,0,0,0-5.255-5.49l2.56-5.79-9.885-4.369-2.561,5.79a23.639,23.639,0,0,0-7.6-.187l-2.279-5.9-10.079,3.905,2.26,5.847a23.539,23.539,0,0,0-5.567,5.255l-5.7-2.515-4.368,9.888,5.626,2.486a23.588,23.588,0,0,0-.212,7.741l-5.7,2.208,3.9,10.081,5.66-2.192a23.588,23.588,0,0,0,5.373,5.662l-2.444,5.531,9.887,4.366,2.445-5.53a23.538,23.538,0,0,0,7.8.161l2.19,5.662,10.079-3.9-2.2-5.7a23.514,23.514,0,0,0,5.581-5.369Zm-31.286-1.694a16.358,16.358,0,1,1,21.574-8.35,16.36,16.36,0,0,1-21.574,8.35"
                                    transform="translate(936.565 265.823)"
                                    fill="#074f4f"
                                />
                                <path
                                    d="M151.51,82.749l2.629-5.956-3.427-1.515a14.146,14.146,0,0,0,.084-4.61l3.518-1.364-2.349-6.07-3.547,1.376a14.265,14.265,0,0,0-3.161-3.306l1.537-3.488-5.953-2.631-1.54,3.486a14.239,14.239,0,0,0-4.575-.112l-1.373-3.548-6.07,2.351,1.364,3.52a14.165,14.165,0,0,0-3.352,3.166l-3.432-1.517-2.629,5.954,3.39,1.5a14.208,14.208,0,0,0-.13,4.659l-3.432,1.332,2.345,6.069,3.409-1.319a14.329,14.329,0,0,0,3.236,3.409l-1.471,3.329,5.953,2.629,1.473-3.327a14.181,14.181,0,0,0,4.7.095l1.319,3.409,6.069-2.351-1.326-3.434a14.281,14.281,0,0,0,3.361-3.232Zm-18.324-2.188A8.577,8.577,0,1,1,144.5,76.186a8.575,8.575,0,0,1-11.314,4.375"
                                    transform="translate(935.45 246.177)"
                                    fill="#ede44f"
                                />
                                <path
                                    d="M64.757,135.612,18.923,241.094H129.666L83.834,135.612Z"
                                    transform="translate(856.852 289.766)"
                                    fill="#ede44f"
                                />
                                <rect width="365.76" height="356.741" transform="translate(842 203)" fill="none" />
                                <g transform="translate(875.776 425.377)">
                                    <g clip-path="url(#clip-path)">
                                        <rect
                                            width="174.338"
                                            height="24.237"
                                            transform="translate(-31.914 64.112)"
                                            fill="#074f4f"
                                        />
                                        <rect
                                            width="174.338"
                                            height="24.241"
                                            transform="translate(-31.914 17.131)"
                                            fill="#074f4f"
                                        />
                                    </g>
                                </g>
                                <path
                                    d="M158.748,199.044a6.629,6.629,0,0,1-6.406,6.834H13.924a6.849,6.849,0,0,1,0-13.671H152.342a6.633,6.633,0,0,1,6.406,6.836"
                                    transform="translate(847.898 334.188)"
                                    fill="#074f4f"
                                />
                                <path
                                    d="M117.644,34.4V23.687h-6.172a23.361,23.361,0,0,0-2.94-7l4.391-4.394-7.577-7.577-4.428,4.428a23.339,23.339,0,0,0-6.961-2.872V0H83.24V6.276a23.339,23.339,0,0,0-6.961,2.872L71.847,4.719,64.27,12.3l4.4,4.394a23.318,23.318,0,0,0-2.941,7H59.553V34.4h6.1a23.269,23.269,0,0,0,2.908,7.1L64.27,45.795l7.577,7.577L76.1,49.118A23.39,23.39,0,0,0,83.24,52.1v5.994H93.957V52.1a23.437,23.437,0,0,0,7.138-2.979l4.252,4.253,7.577-7.577-4.286-4.289a23.4,23.4,0,0,0,2.908-7.1ZM88.6,39.48A10.293,10.293,0,1,1,98.89,29.187,10.294,10.294,0,0,1,88.6,39.48"
                                    transform="translate(888.743 203)"
                                    fill="#ede44f"
                                />
                            </g>
                        </svg>
                        {/* <div>
                            {error.message}
                            {error.digest && <> ({error.digest})</>}
                        </div> */}
                    </div>
                </div>
            </body>
        </html>
    );
}
